"use strict";

module.exports = {
  PENDING: 'PENDING',
  DONE: 'DONE',
  FAILED: 'FAILED',
  IGNORED: 'IGNORED'
};